(function () {
if (!window.jQuery) return;

var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
if (root === "/") return;
var DEBUG = true; 
var pendingPage = null;
document.addEventListener("click", function (e) {
    var a = e.target.closest(".js-collection-loadmore a");
    if (!a) return;
    var m = (a.getAttribute("href") || "").match(/[?&]page=(\d+)/);
    pendingPage = m ? m[1] : null;
}, true); 
jQuery.ajaxPrefilter(function (options) {
    if (!options.url) return;

    var u = new URL(options.url, window.location.origin);
    if (u.origin !== window.location.origin) return;
    if (!/^\/([a-z]{2}(-[a-z]{2})?\/)?(collections|search)(\/|$)/i.test(u.pathname)) return;

    var before = options.url;
    if (u.pathname.indexOf(root) !== 0) {
     u.pathname = root.replace(/\/$/, "") + u.pathname;
    }

    if (pendingPage) {
     u.searchParams.set("page", pendingPage);
     pendingPage = null;
    } else {
     var pages = u.searchParams.getAll("page");
     if (pages.length > 1) u.searchParams.set("page", pages[0]);
    }
    options.url = u.pathname + u.search;
    if (DEBUG) console.log("[locale-fix]", before, "→", options.url);
});
})();